<template lang="pug">
#selecionar-territorio
    el-input.mb-3(
        :placeholder="$t('mensagens.laudos.procurePorUmTerritorioCarOuPessoaVinculada')",
        prefix-icon='el-icon-search',
        v-model='filtroSelecionarTerritorio',
        @change='findAllTerritoriosSimplificado',
        @keyup.native.enter='findAllTerritoriosSimplificado'
    )
    .conteudo(v-if='!existeRetornoSimplificadoCar')
        h4 {{ $t('mensagens.laudos.selecioneUmOuMaisTerritoriosParaSolicitacaoDeLaudos') }}
        .selecionados.mb-2(v-if='territoriosSelecionados')
            el-checkbox.ml-0(
                v-for='(territorio, index) in territoriosSelecionados',
                checked,
                @change='desselecionarTerritorio(index)',
                :key='territorio.id'
            )
                p.m-0
                    b {{ territorio.nome }}
                    br
                    em {{ territorio.totalCARs }} {{ territorio.totalCARs <= 1 ? $t('mensagens.laudos.car') : $t('mensagens.laudos.cars') }}
                el-divider.item-divider

        .nao-selecionados(v-if='territoriosNaoSelecionados')
            el-checkbox.ml-0(
                v-for='(territorio, index) in territoriosNaoSelecionados',
                @change='selecionarTerritorio(index)',
                :key='territorio.id',
                :disabled='territorio.totalCARs === 0'
            )
                p.m-0
                    b {{ territorio.nome }}
                    br
                    em {{ territorio.totalCARs }} {{ territorio.totalCARs <= 1 ? $t('mensagens.laudos.car') : $t('mensagens.laudos.cars') }}
                el-divider.item-divider
    .py-3(style='text-align: right', v-if='!existeRetornoSimplificadoCar')
        el-pagination(
            :pager-count='5',
            :page-size='pageParams.size',
            :current-page.sync='pageParams.page',
            layout='prev, pager, next',
            :total='totalTerritorios',
            @current-change='findAllTerritoriosSimplificado'
        )
    .sem-resultado(v-if='existeRetornoSimplificadoCar')
        .msg-geral
            .i.mdi.mdi-close-circle.mr-2(style='color: #740F0F; font-size: 18px')
            .alerta-error {{ $t('mensagens.laudos.naoFoiPossivelEncontrarInformacaoInserida') }}
                br
                | {{ $t('mensagens.laudos.carNaoVinculadoAoTerritorioParaPoderSolicitarLaudo') }}
                br
                | {{ $t('mensagens.laudos.conformidadeAmbientalDoCar') }}

        p {{ $t('mensagens.laudos.desejaCadastrarUmNovoTerritorio') }}?
            .botao.marginButton(slot='footer')
                BaseButton(
                    icon='el-icon-circle-plus-outline',
                    type='primary',
                    size='small',
                    @click='cadastrarTerritorio'
                )(style='width: 100%')
                    | {{ $t('mensagens.laudos.cadastrarTerritorio') }}
    el-divider.custom-divider
    .botao.marginButton(slot='footer')
        BaseButton(type='outline', @click='cancelarModal') {{ $t('mensagens.comuns.cancelar') }}
        BaseButton(
            type='primary',
            @click='enviarTerritoriosSelecionados',
            :disabled='territoriosSelecionados.length < 1'
        )
            | {{ $t('mensagens.comuns.adicionar') }}
</template>

<script>
import TerritorioService from '@/services/TerritorioService';
import formatters from '@/utils/formatters';
import { ordem } from '@/utils/ordenacao';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'SelecionarTerritorio',
    components: {
        BaseButton
    },
    props: {
        selecionados: {
            type: [],
            default() {
                return [];
            }
        }
    },

    emits: ['getTerritoriosSelecionados'],

    data() {
        return {
            filtroSelecionarTerritorio: '',
            territoriosSelecionados: [],
            territoriosNaoSelecionados: [],
            pageParams: {
                page: 1,
                size: 8
            },
            totalTerritorios: 0,
            existeRetornoSimplificadoCar: false,
            tipoPesquisa: null
        };
    },
    watch: {
        filtroSelecionarTerritorio: function (value) {
            const tipoPesquisa = {
                0: null,
                43: 'CODIGOCAR'
            };

            this.tipoPesquisa = tipoPesquisa[value.length];
            if (this.tipoPesquisa === null) {
                this.findAllTerritoriosSimplificado();
            }
        }
    },
    mounted() {
        this.ajustarJaSelecionados();

        window.addEventListener('keydown', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        });
    },

    methods: {
        getFiltroSelecionarTerritorio() {
            if (this.filtroSelecionarTerritorio) {
                const cpfCnpj = formatters.documentoFormatToNumeral(
                    this.filtroSelecionarTerritorio
                );

                return cpfCnpj === ''
                    ? this.filtroSelecionarTerritorio
                    : cpfCnpj;
            }

            return '';
        },

        async findAllTerritoriosSimplificado() {
            const filtro = {};
            filtro.size = this.pageParams.size;
            filtro.page = this.pageParams.page - 1;
            try {
                const { data } = await TerritorioService.findAllSimplificadoPaginado(
                    filtro,
                    this.getFiltroSelecionarTerritorio()
                );
                this.territoriosNaoSelecionados = [];

                data.content.forEach(territorio => {
                    this.territoriosNaoSelecionados.push({
                        ...territorio
                    });
                });
                this.totalTerritorios = data.totalElements;
                this.existeRetornoSimplificadoCar = false;
                await this.findTerritorioSimplificadoPorCar();
                this.organizar();
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.ocorreuUmErroAoBuscarTerritorios')
                });
            }
        },

        async findTerritorioSimplificadoPorCar() {
            try {
                const filtro = {};
                filtro.size = this.pageParams.size;
                filtro.page = this.pageParams.page - 1;
                if (this.filtroSelecionarTerritorio) {
                    const { data } =
                        await TerritorioService.findSimplificadoPorCarPaginado(
                            filtro,
                            this.filtroSelecionarTerritorio
                        );

                    data.content.forEach(territorio => {
                        this.territoriosNaoSelecionados.push({
                            ...territorio
                        });
                    });
                    this.totalTerritorios = data.totalElements;
                    this.existeRetornoSimplificadoCar = data.totalElements === 0 && this.tipoPesquisa === 'CODIGOCAR';
                }
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.ocorreuUmErroAoBuscarTerritorios')
                });
            }
        },

        selecionarTerritorio(index) {
            this.territoriosSelecionados.push(
                this.territoriosNaoSelecionados[index]
            );
            this.territoriosNaoSelecionados.splice(index, 1);
            this.organizar();
        },

        desselecionarTerritorio(index) {
            this.territoriosNaoSelecionados.push(
                this.territoriosSelecionados[index]
            );
            this.territoriosSelecionados.splice(index, 1);
            this.findAllTerritoriosSimplificado();
        },

        desselecionarTodosTerritorios() {
            this.territoriosSelecionados.map((value, index) => {
                this.desselecionarTerritorio(index);
            });
        },

        organizar() {
            const filtro = a => {
                let encontrado = false;
                this.territoriosSelecionados.forEach(({ id }) => {
                    if (a.id === id) {
                        encontrado = true;
                    }
                });
                return !encontrado;
            };

            this.territoriosSelecionados.sort((a, b) => ordem(a, b));
            this.territoriosNaoSelecionados.sort((a, b) => ordem(a, b));

            this.territoriosNaoSelecionados =
                this.territoriosNaoSelecionados.filter(territorio =>
                    filtro(territorio)
                );
        },

        enviarTerritoriosSelecionados() {
            const territoriosSelecionadosExtensao = [...this.territoriosSelecionados];
            this.$emit(
                'getTerritoriosSelecionados',
                territoriosSelecionadosExtensao
            );
        },
        ajustarJaSelecionados() {
            this.selecionados.forEach(({ id, nome, representantes }) => {
                this.territoriosSelecionados.push({
                    id,
                    nome,
                    totalRepresentantes: representantes.length
                });
            });
            this.findAllTerritoriosSimplificado();
        },
        cancelarModal() {
            this.$emit('cancelar-modal-carbono');
        },
        cadastrarTerritorio() {
            this.$router.push({
                name: 'CadastrarEditarTerritorio'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
#selecionar-territorio {
    margin-top: -40px;

    .conteudo {
        min-height: 33vh;
        max-height: 60vh;
        overflow-y: auto;
    }

    .selecionados,
    .nao-selecionados {
        display: flex;
        flex-direction: column;

        .el-checkbox {
            width: 100%;
            display: flex;
            align-items: center;

            .el-checkbox__label {
                display: flex;
                flex-direction: column;

                p {
                    line-height: 16px;
                }
            }

            em {
                font-weight: 200;
                font-size: 12px;
            }
        }
    }

    .botao {
        margin-top: 0px;
        text-align: right;
        display: flex;
        justify-content: space-between;
    }

    .custom-divider {
        margin-bottom: 10px;
        margin-top: 0px;
    }

    .item-divider {
        margin: 7px 0 7px 0px;
        width: 35vw;
    }

    .msg-box {
        border: 1px solid #e68484;
        border-radius: 5px;
        padding: 14px 5px;
        color: #2f2f30;
        font-weight: 500;
        margin: 20px 0;
    }

    .msg-geral {
        border-radius: 5px;
        padding: 14px 5px;
        font-weight: 500;
        margin-bottom: 13px;
        border: 1px solid #DE1A1A;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .alerta-error {
        margin: 5px 10px 5px 10px;
        max-width: 90%;
        text-align: left;
    }
}
</style>
